import React, {Fragment} from "react";
import {
  Badge,
  Button,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from "reactstrap";
import SFXButtonComponent from "./SFXButtonComponent";

const HEADER_STYLE = {
  fontSize: "11pt"
};
const BODY_STYLE = {
  marginBottom: "0px"
};

export default class ItemAssignmentComponent extends React.Component {


  constructor(props) {
    super(props);

    this.copyRef = null;

    this.filterValues = this.props.filterDataFields !== undefined
      ? this.props.filterDataFields
      : [this.props.dataFieldName, this.props.dataFieldDescription];

    let serverAssignedIds = this.props.itemsAssigned === undefined ? [] : this.props.itemsAssigned;

    this.state = {
      serverAssignedIds: serverAssignedIds,
      selectedIds: [...serverAssignedIds],
      renderIndexes: this.getRenderIndexes("", props),
      searchText: "",
      isImportExportOpen: false,
      csvData: [...serverAssignedIds]
    };

    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.resetSelection = this.resetSelection.bind(this);
  }

  componentWillReceiveProps(newProps) {

    let serverAssignedIds = newProps.itemsAssigned === undefined ? [] : newProps.itemsAssigned;

    this.setState({
      serverAssignedIds: serverAssignedIds,
      selectedIds: JSON.parse(JSON.stringify(serverAssignedIds)),
      renderIndexes: this.getRenderIndexes(this.state.searchText, newProps)
    })

  }

  getSelectedIds() {
    return this.state.selectedIds;
  }


  resetSelection() {
    this.setState({
      selectedIds: JSON.parse(JSON.stringify(this.state.serverAssignedIds))
    })
  }

  addItem(item_id) {
    if (this.isEditable()) {
      let selectedIds = this.state.selectedIds;
      selectedIds.push(item_id);
      this.setState({
        selectedIds: selectedIds,
        csvData: [...selectedIds]
      })
    }
  }

  removeItem(item_id) {
    if (this.isEditable()) {
      let selectedIds = this.state.selectedIds;
      let indexof = selectedIds.indexOf(item_id);
      if (indexof >= 0) {
        selectedIds.splice(indexof, 1);
        this.setState({
          selectedIds: selectedIds,
          csvData: [...selectedIds]
        })
      }
    }
  }

  onCsvDataChange(event) {
    this.setState({
      csvData: event.target.value
    })
  }

  btnCopyClick() {
    this.copyRef.select();
    document.execCommand("copy");
  }

  btnImportClick() {

    let csvData = this.state.csvData || "";
    let newValues;
    if (Array.isArray(csvData)) {
      newValues = [...csvData];
    }
    else {
      newValues = [];
      if (csvData.length > 0) {
        let stringValues = csvData.split(',');
        stringValues.forEach(stringValue => {
          let intValue = parseInt(stringValue, 10);
          if (!isNaN(intValue))
            newValues.push(intValue);
        });
      }
    }

    this.setState({
      selectedIds: newValues,
      csvData: [...this.state.selectedIds],
      isImportExportOpen: false
    });
  }

  btnExportClick() {
    this.setState({
      csvData: [...this.state.selectedIds]
    });
  }

  filter(e) {

    let searchText = e.target.value;
    let renderIndexes = this.getRenderIndexes(searchText);

    this.setState({
      searchText: searchText,
      renderIndexes: renderIndexes
    })
  }

  getRenderIndexes(searchText, props = this.props) {

    let renderIndexes = [];
    searchText = searchText.toLowerCase();
    if(props.items) {
      props.items.forEach((singleItem, index) => {

        for (let i = 0; i < this.filterValues.length; i++) {
          if (singleItem[this.filterValues[i]] === undefined) continue;
          if (singleItem[this.filterValues[i]].toString().toLowerCase().indexOf(searchText) >= 0) {
            renderIndexes.push(index);
            break;
          }
        }
      });
    }
    return renderIndexes;
  }

  isEditable() {
    return this.props.readOnly === undefined || this.props.readOnly === false;
  }

  render() {
    let maxHeight = "65vh";
    return <Fragment>
      {
        this.isEditable() && <form>
          <InputGroup>
            <Input type="text"
                   placeholder={"Search"}
                   value={this.state.searchText}
                   onChange={this.filter.bind(this)}
            />
            <InputGroupAddon addonType="append">
              <Button
                onClick={() => {
                  this.setState({
                    isImportExportOpen: true
                  })
                }
                }
              >
                <i className={"fa fa-link"}/>
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </form>
      }
      <br/>
      <Row>
        {this.isEditable() && <Col md={6}>

          <ListGroup>
            <ListGroupItem className={"info"}>
              <strong>Available: {(this.props.items || []).length - this.state.selectedIds.length}</strong>
            </ListGroupItem>
          </ListGroup>
          <ListGroup style={{maxHeight: maxHeight, overflowY: "scroll", cursor: "pointer"}}>
            {
              this.state.renderIndexes.map((index) => {
                let singleItem = this.props.items[index];
                return this.createUnassignedItem(singleItem);

              })
            }
          </ListGroup>
        </Col>
        }
        <Col md={6}>
          <ListGroup variant={"flush"}>
            <ListGroupItem>
              <strong>Assigned: {this.state.selectedIds.length}</strong>
            </ListGroupItem>
          </ListGroup>
          <ListGroup style={{maxHeight: maxHeight, overflowY: "scroll", cursor: "pointer"}}>
            {
              this.state.renderIndexes.map((index) => {
                let singleItem = this.props.items[index];
                return this.createAssignedItem(singleItem);
              })
            }
          </ListGroup>
        </Col>
      </Row>
      {this.createImportExport()}
    </Fragment>
  }

  createUnassignedItem(singleItem) {
    let id = singleItem[this.props.dataFieldId];
    if (this.state.selectedIds.indexOf(id) >= 0)
      return <Fragment key={id}/>
    else {
      let isOld = this.state.serverAssignedIds.indexOf(id) >= 0;
      return <ListGroupItem
        key={id}
        className="justify-content-between"
        tag="a"
        action
        onClick={() => {
          this.addItem(id)
        }}
      >
        {this.isEditable() && <i className={"fa fa-angle-right fa-2x pull-right"}/>}
        <ListGroupItemHeading
          style={HEADER_STYLE}>
          {singleItem[this.props.dataFieldName]}
          {isOld && <Badge className="mr-1 pull-right" color="danger">Unassigned</Badge>}
        </ListGroupItemHeading>
        <ListGroupItemText
          style={BODY_STYLE}>
          <Label style={{whiteSpace: "pre-wrap"}}>
            {this.createDescription(singleItem)}
          </Label>
        </ListGroupItemText>
      </ListGroupItem>
    }
  }

  createAssignedItem(singleItem, side) {
    let id = singleItem[this.props.dataFieldId];
    if (this.state.selectedIds.indexOf(id) < 0)
      return <Fragment key={id}/>
    else {
      let isNew = this.state.serverAssignedIds.indexOf(id) < 0;
      return <ListGroupItem
        key={id}
        tag="a"
        action
        onClick={() => {
          this.removeItem(id)
        }}
      >
        {this.isEditable() && <i className={"fa fa-angle-left fa-2x pull-left"}/>}
        <ListGroupItemHeading
          style={HEADER_STYLE}
        >
          {singleItem[this.props.dataFieldName]}
          {isNew && <Badge className="mr-1 pull-right" color="success">New</Badge>}
        </ListGroupItemHeading>
        <ListGroupItemText
          style={BODY_STYLE}>
          <Label style={{whiteSpace: "pre-wrap"}}>
            {this.createDescription(singleItem)}

          </Label>
        </ListGroupItemText>

      </ListGroupItem>
    }
  }

  createDescription(singleItem) {

    let description = "";
    if (this.props.formatDescription)
      description = this.props.formatDescription(singleItem);
    else
      description = singleItem[this.props.dataFieldDescription];

    return <Fragment>
      {description}
    </Fragment>
  }

  createImportExport() {
    return <Fragment>
      <Modal isOpen={this.state.isImportExportOpen}
             className={'modal-info modal-sd ' + this.props.className}>
        <ModalHeader>{this.props.title || "Import/Export"}</ModalHeader>
        <ModalBody>
          <form>
          <textarea ref={copyRef => this.copyRef = copyRef}
                    value={this.state.csvData}
                    style={{
                      width: "100%"
                    }}
                    onChange={this.onCsvDataChange.bind(this)}
          />
          </form>
        </ModalBody>
        <ModalFooter>
          <SFXButtonComponent className={"btn btn-success"}
                              onClick={this.btnCopyClick.bind(this)}>Copy</SFXButtonComponent>
          <SFXButtonComponent className={"btn btn-success"}
                              onClick={this.btnImportClick.bind(this)}>Import</SFXButtonComponent>
          <SFXButtonComponent className={"btn btn-secondary"} onClick={() => {
            this.setState({
              isImportExportOpen: false
            })
          }

          }>Cancel</SFXButtonComponent>
        </ModalFooter>
      </Modal>
    </Fragment>;
  }

}
